import { AlertColor } from "@mui/material"
import useShowToast from "./useShowToast"
import { useCallback } from "react"

export default function useShowError() {
  const showToast = useShowToast()

  return useCallback(
    (message: string) => {
      showToast(message, { severity: "error" as AlertColor })
    },
    [showToast],
  )
}
